import { render, staticRenderFns } from "./dispute-dialog-booking-history.vue?vue&type=template&id=1084135b"
import script from "./dispute-dialog-booking-history.vue?vue&type=script&lang=js"
export * from "./dispute-dialog-booking-history.vue?vue&type=script&lang=js"
import style0 from "./dispute-dialog-booking-history.vue?vue&type=style&index=0&id=1084135b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports